import { getFirestore, doc, getDoc, updateDoc } from "firebase/firestore";

export async function setExpressLabel(firebaseApp, jobId, checked) {
  const db = getFirestore(firebaseApp);
  const expressID = "5f0e8630fb83455e28da9908";
  const jobDocRef = doc(db, "JobData", jobId);
  const jobDataRaw = await getDoc(jobDocRef);
  const jobData = jobDataRaw.data();

  if (checked) {
    if (jobData.idLabels.indexOf(expressID) === -1) {
      jobData.idLabels.push(expressID);
    }
  } else {
    if (jobData.idLabels.indexOf(expressID) !== -1) {
      jobData.idLabels.splice(jobData.idLabels.indexOf(expressID), 1);
    }
  }
  const noDupes = [...new Set(jobData.idLabels)];
  jobData.idLabels = noDupes;

  await updateDoc(jobDocRef, { idLabels: jobData.idLabels });
}
